module.exports = __webpack_public_path__ + "static/media/walubita.10296b20.jpg";